import React from 'react'
import { useState } from 'react'
import { Link } from 'gatsby'
import tw, { styled } from 'twin.macro'

import { CheckSquare, Square } from 'react-feather'

const Switch = (settings) => {
    const [ toggle, setToggle ] = useState(settings.initialState === 'off' ? false : true)
    const [ gst, setGst ] = useState(settings.includeGSTtoggle ? 'excl' : 'incl')

    let grid = toggle === true ? settings.grids.at(0) : settings.grids.at(1);

    const msg = toggle === true ? (
        <span>
            <h2>Save with <a href="/multisaver">Multisaver</a></h2>
            <p>When you have 2 or more eligible services.<br />Discounts have been applied below.</p>
        </span>
    ) : (<span>
            <h2>Save with <a href="/multisaver">Multisaver</a></h2>
            <p>When you have 2 or more eligible services.<br />Flick the switch to <b>YES</b> to see discounted Multisaver prices.</p>
        </span>
    );

    const toggleGST = (e) => {
        //offer-grid
        document.querySelectorAll('.offer-grid').forEach(grid => grid.classList.toggle('inc-gst'))
    }

    if (settings?.includeGSTtoggle) {
        settings = { ...settings, 'data-gst': gst }
    }

    return (
        <Style className="offer-grid-switch" data-show={grid} {...settings}>
            {settings.text && (
                <div className="prose">
                    {msg}
                    {settings?.includeGSTtoggle ? (
                        <div className="switch__gst-toggle w-full mt-4">

                            <div className="checkbox">
                                <button className="inline-flex outline-none focus-visible:text-orange items-center gap-x-2" type="button" onClick={() => setGst(gst === 'excl' ? 'incl' : 'excl')}>
                                {gst === 'incl' ? <Square aria-hidden="true" /> : <CheckSquare aria-hidden="true" />}
                                Excl. GST</button>
                            </div>
                        {/*}
                            <div className="switch">
                                <span aria-hidden="true">GST excluded</span>
                                <button aria-label={`Turn ${gst === 'incl' ? 'on' : 'off'}`} aria-pressed={gst === 'incl'} type="button" onClick={() => setGst(gst === 'excl' ? 'incl' : 'excl')}>
                                    <span aria-hidden="true">{gst === 'incl' ? 'On' : 'Off'}</span>
                                </button>
                                <span aria-hidden="true">GST included</span>
                    </div>*/}
                        </div>
                    ) : null}
                </div>
            )}
            <div className="switch">
                <span aria-hidden="true">No</span>
                <button aria-label={`Turn ${toggle === false ? 'on' : 'off'}`} aria-pressed={toggle} type="button" onClick={() => setToggle(!toggle)}>
                    <span aria-hidden="true">{toggle === false ? 'On' : 'Off'}</span>
                </button>
                <span aria-hidden="true">Yes</span>
            </div>

        </Style>
    )
}
export default Switch

const Style = styled.div`
    ${tw `w-full xl:container mx-auto px-4 relative flex flex-wrap gap-y-6 lg:gap-x-10 justify-center items-center mt-14 lg:mt-16 md:-mb-16 lg:-mb-16`}

    ~ .offer-grid {
        ${tw `hidden`}
    }

    h2 a {
        ${tw `hover:text-teal focus-visible:text-teal`}
    }

    .prose {
        ${tw `flex-1 max-w-lg`}

        p {
            ${tw `text-xl mb-0 block`}
        }

        span > p:first-of-type {
            ${tw `mt-2 -mb-1`}
        }
    }

    .switch {
        ${tw `flex items-center gap-x-2 text-2xl font-semibold`}
    }

    .switch button {
        ${tw `h-14 w-24 bg-orange border-4 border-orange relative`}
        border-radius: 32px;

        span {
            ${tw `h-12 w-12 absolute bg-white block rounded-full flex top-0 left-0 transition-all shadow-lg`}
            text-indent: -5000em;
        }

        &[aria-pressed="true"] {
            ${tw `bg-[var(--nova-green)] border-[var(--nova-green)]`}
        }

        &[aria-pressed="true"] > span {
            ${tw `left-10`}
        }
    }

    .switch__gst-toggle .switch {
        ${tw `text-base`}

        button {
            ${tw `h-10 w-16`}

            span {
                ${tw `h-8 w-8`}
            }

            &[aria-pressed="true"] > span {
                ${tw `left-6`}
            }
        }
    }

    ${({grids}) => grids.map(grid => `&[data-show="${grid}"] ~ #${grid} { display: block; }`)}
`